import React, { Component } from 'react'
import { connect } from 'react-redux'
import cx from 'classnames'
import { bindActionCreators } from 'redux'
import { compose, branch, mapProps, renderNothing } from 'recompose'
import moment from 'moment-timezone'
import * as MessageSelectors from 'app/modules/message/selectors'

import { Icon } from '@driftt/tide-core-legacy'

import * as style from './style'

import GEO_PIN from '!svg-inline?removeTags=true!images/svg/location-pin.svg'

class TimeStamp extends Component {
  constructor(props) {
    super(props)

    this.state = {
      minutes: moment().minutes(),
    }
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({ minutes: moment().minutes() })
    }, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (nextState.minutes !== this.state.minutes) || (nextProps.timezone !== this.props.timezone)
  }

  render() {
    const { timezone } = this.props
    const timestamp = moment()
    return (
      <span>
        {timezone ? moment().tz(timezone).format('h:mm A') : moment().format('h:mm A')}
      </span>
    )
  }
}

class LocalTime extends Component {
  formatGeolocation = ({ city, region, country }) => {
    return _.compact([city, region, country]).join(', ')
  }

  render() {
    const {
      className,
      geolocation,
      timezone,
    } = this.props

    return (
      <div className={cx(style.localTime, className, 'flex-row icon-row')}>
        <span>
          <Icon width={13} height={13} name="location-2" className="icon" />
        </span>
        <span className="geolocation">
          <TimeStamp timezone={timezone} />
          {_.get(geolocation, 'country') && ` - ${this.formatGeolocation(geolocation)}`}
        </span>
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const lastEndUserMessageSelector = MessageSelectors.lastEndUserMessage()

  return (state, props) => {
    const { conversationId } = props

    return {
      lastEndUserMessage: lastEndUserMessageSelector(state, { conversationId }),
    }
  }
}

export default compose(
  connect(makeMapStateToProps),
  branch(props => !props.endUser, renderNothing),
  branch(props => !props.lastEndUserMessage, renderNothing),
  mapProps(({ lastEndUserMessage, ...props }) => {
    const geolocation = lastEndUserMessage.getIn(['context', 'location'])
    const timezone = lastEndUserMessage.getIn(['context', 'timezone'])

    return {
      geolocation: geolocation && geolocation.toJS(),
      timezone,
      ...props,
    }
  }),
)(LocalTime)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/Profile/LocalTime/index.js